module.exports = __webpack_public_path__ + "static/media/gallery_02_thumb.611be663.jpg";